export default {
  nav: {
    title: 'Nueva reserva',
    edit: 'Editar reserva'
  },
  actions: {
    create: 'Crear'
  },
  form: {
    mandatory: {
      facility: 'Instalación*',
      checkin_date: 'Fecha de checkin*',
      checkin_time: 'Hora de checkin*',
      name: 'Nombre*',
      currency: 'Divisa*',
      default_currency: 'Divisa por defecto*'
    },
    status: 'Estado',
    checkout_date: 'Fecha de checkout',
    checkout_time: 'Hora de checkout',
    last_name: 'Apellido',
    email: 'E-mail',
    phone_number: 'Número de teléfono',
    birth_date: 'Fecha de nacimiento',
    language: 'Idioma',
    gender: 'Género',
    genders: {
      FEMALE: 'Femenino',
      MALE: 'Masculino',
      OTHER: 'Otro'
    },
    profile_type: 'Tipo de perfil',
    profile_category: 'Categoria de perfil',
    balance: 'Saldo',
    postpaid: 'Pospago',
    selector_values: {
      NEW: 'Nuevo/a',
      NONE: 'Ninguno/a',
      NO_ROOM: 'Sin habitación'
    },
    room: 'Habitación',
    guest_type: 'Tipo de huésped',
    guest_category: 'Categoria de huésped'
  },
  sections: {
    booking_info: 'Información general de la reserva',
    booking_profile: 'Perfil de la reserva',
    other_options: 'Otras opciones',
    booking_account: 'Cuenta de la reserva',
    add_currency: 'Añadir divisa',
    guest: 'Huésped',
    delete_guest: 'Eliminar huésped',
    add_guest: 'Añadir huésped',
    room: 'Habitación',
    delete_room: 'Eliminar habitación',
    add_room: 'Añadir habitación',
    room_account: 'Cuenta de la habitación',
    guest_account: 'Cuenta del huésped'
  },
  errors: {
    mandatory: 'Campo obligatorio'
  },
  post: {
    success_message: 'Reserva creada con éxito',
    error_message: 'Corrige los errores'
  }
}
